module.exports = __webpack_public_path__ + "img/top-howto4.4b7a8f68.png";